import React, { useState, useEffect } from "react";
import { TextField, InputAdornment } from "@mui/material";
import "./components.css";
import { getLocalizedFieldLabel } from "../helpers/helpers";

export default function AmountFieldComponent(props) {
  const { questionKey, value, onChange, label, lang } = props;
  const [displayValue, setDisplayValue] = useState(value);

  useEffect(() => {
    setDisplayValue(formatNumber(value));
  }, [value]);

  const handleChange = (e) => {
    const val = e.target.value.replace(/,/g, '');
    if (val.length > 9) return;
    const parsedValue = val === "" ? "" : parseFloat(val);
    onChange(questionKey, parsedValue);
  };

  const formatNumber = (num) => {
    if (num === "" || isNaN(num)) return "";
    return num.toLocaleString();
  };

  return (
    <div className="flexAlignColumnClassName">
      <TextField
        label={getLocalizedFieldLabel(questionKey, lang) || label}
        autoComplete="off"
        type="text"
        id={`outlined-number-${questionKey}`}
        className="numberFieldInputComponent"
        value={displayValue}
        onChange={handleChange}
        onBlur={() => setDisplayValue(formatNumber(value))}
        onFocus={() => setDisplayValue(value)}
        inputProps={{ maxLength: 12 }} 
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
          classes: {
            root: "outlinedInputRoot",
            focused: "outlinedInputFocused",
            notchedOutline: "outlinedInput",
          },
        }}
        InputLabelProps={{
          classes: {
            root: "outlinedInputLabel",
            focused: "focusedInputLabel"
          }
        }}
      />
    </div>
  );
}
